import { motion } from 'motion/react';
import { Trash2 } from 'lucide-react';
import { useLandingContent } from '../../lib/content';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function ClearConfirmModal({ open, onClose, onConfirm }: Props) {
  const { modals } = useLandingContent('modals');
  const m = modals.clearConfirm ?? {
    title: 'Reset Progress?',
    body: 'You will lose your current box configuration. Continue?',
    cta: 'Continue',
  };
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="absolute inset-0 bg-black/60 backdrop-blur-md"
        onClick={onClose}
      />
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 20 }}
        className="relative bg-white rounded-3xl p-8 max-w-sm w-full shadow-2xl text-center"
      >
        <div className="w-16 h-16 bg-[#57c858]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <Trash2 className="w-8 h-8 text-[#356d4e]" />
        </div>
        <h3 className="text-2xl font-bold mb-2 text-[#444444]">{m.title}</h3>
        <p className="text-gray-600 mb-8 leading-relaxed">{m.body}</p>
        <div className="grid grid-cols-2 gap-4">
          <button
            onClick={onClose}
            className="py-4 bg-gray-100 text-gray-600 rounded-xl font-bold hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="py-4 bg-linear-to-br from-[#356d4e] to-[#57c858] text-white rounded-xl font-bold hover:scale-105 transition-all shadow-lg"
          >
            {m.cta ?? 'Continue'}
          </button>
        </div>
      </motion.div>
    </div>
  );
}
